<template lang="pug">
    .animation(ref='animation')
        .bath-bessom(ref='bathBessom')
            img(src='../../assets/img/animations/bath-bessom.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline.fromTo(
                this.$refs.bathBessom,
                {rotate: -20},
                {
                    keyframes: [
                        {duration: 1, rotate: 20, transformOrigin: '90% 90%', ease: 'none'},
                        {duration: 1, rotate: -20, transformOrigin: '90% 90%', ease: 'none'},
                        {duration: 1, rotate: 20, transformOrigin: '90% 90%', ease: 'none'},
                        {duration: 1, rotate: -20, transformOrigin: '90% 90%', ease: 'none'},
                        {duration: 1, rotate: 20, transformOrigin: '90% 90%', ease: 'none'}
                    ]
                },
                0
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    position: relative;
}
.bath-bessom {
    width: fit-content;
}
</style>
